import { useCurrentStateAndParams } from '@uirouter/react';

import { Widget } from '@@/Widget/Widget';
import { WidgetBody } from '@@/Widget';
import { InlineLoader } from '@@/InlineLoader';

import { useCustomResource } from '../queries/useCustomResource';
import { useNamespaceQuery } from '../../namespaces/queries/useNamespaceQuery';
import { YAMLInspector } from '../../components/YAMLInspector';
import { Application } from '../ListView/ApplicationsDatatable/types';

export function CustomResourceYAML({
  application,
  isInitialLoading: isApplicationLoading,
}: {
  application?: Application;
  isInitialLoading: boolean;
}) {
  const stateAndParams = useCurrentStateAndParams();
  const {
    params: { namespace, name, endpointId: environmentId },
  } = stateAndParams;

  const namespaceData = useNamespaceQuery(environmentId, namespace);
  const isSystemNamespace = namespaceData.data?.IsSystem;

  const {
    data: fullApplicationYaml,
    isInitialLoading: isApplicationYAMLLoading,
  } = useCustomResource(
    environmentId,
    namespace,
    name,
    application?.CustomResourceMetadata?.apiVersion ?? '',
    application?.CustomResourceMetadata?.plural ?? '',
    { yaml: true }
  );

  const loading = isApplicationLoading || isApplicationYAMLLoading;

  if (loading) {
    return (
      <div className="row">
        <div className="col-sm-12">
          <Widget>
            <WidgetBody>
              <InlineLoader>Loading...</InlineLoader>
            </WidgetBody>
          </Widget>
        </div>
      </div>
    );
  }

  return (
    <div className="row">
      <div className="col-sm-12">
        <Widget>
          <WidgetBody>
            <YAMLInspector
              identifier="application-yaml"
              data={fullApplicationYaml as string}
              authorised
              system={isSystemNamespace}
              hideMessage
              resourcePlural={application?.CustomResourceMetadata?.plural}
              data-cy="application-yaml"
            />
          </WidgetBody>
        </Widget>
      </div>
    </div>
  );
}
